import { render, staticRenderFns } from "./folderForm.vue?vue&type=template&id=d9c85eec&scoped=true"
import script from "./folderForm.vue?vue&type=script&lang=js"
export * from "./folderForm.vue?vue&type=script&lang=js"
import style0 from "./folderForm.vue?vue&type=style&index=0&id=d9c85eec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c85eec",
  null
  
)

export default component.exports